import axios from 'axios';

// const baseURL = `http://foodna-api.codebnb.me/api/v0`;
const baseURL = `https://foodna-api.codebnb.me/api/v0`;

const instance = axios.create({ baseURL });

export default instance;



// WEBPACK FOOTER //
// ./src/config/axios.js